import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PageScrollTop from './components/pageToTop/PageScrollTop';
import Freelancer from './pages/Freelancer';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';

// Import Css Here
import './assets/scss/style.scss';

const App = () => {
  return (
    <Router>
      <PageScrollTop>
        <Routes>
          <Route path="/" element={<Freelancer />} />
          <Route path="/services" element={<Freelancer />} />
          <Route path="/process" element={<Freelancer />} />
          <Route path="/cases" element={<Freelancer />} />
          <Route path="/faq" element={<Freelancer />} />
          <Route path="/projects" element={<Freelancer />} />
          <Route path="/work-experience" element={<Freelancer />} />
          <Route path="/contact-section" element={<Freelancer />} />
          <Route path="/contact" element={<Freelancer />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route
            path="/terms-and-conditions"
            element={<TermsAndConditions />}
          />
        </Routes>
      </PageScrollTop>
    </Router>
  );
};

export default App;
